module.exports = __webpack_public_path__ + "media/customizations/riverlights/logo-new-2beb3fbb80b205f2d4f1fa27b125a1a4.png";